<template>
  <CSidebar
    v-if="true"
    class="asideBar bg-white asideBar--fixed"
    flat
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :contentToRender="navItems" class="py-5" />
  </CSidebar>
</template>

<script>
import navItems from './_navItems'
export default {
  name: 'TheAside',
  extends: navItems,
  data() {
    return {
      showSideBar: true,
    }
  },

  computed: {
    show() {
      return true
    },

    minimize() {
      return this.$store.state.sidebarMinimize
    },

    canCreateSubOrganization() {
      return this.$store.getters['auth/subOrganizationMaxCount'] ? true : false
    },
  },

  created() {
    this.openMenubyRoute()
  },

  methods: {
    openMenubyRoute() {
      // ? Verifica o objeto que deve ser usado com base se há o organizatinoId nas rotas
      if (this.$route.params.organizationId) {
        this.navItems[0]._children.forEach((element) => {
          element.show = element.id?.toUpperCase() === this.$route.meta.menuType.toUpperCase()
        })
      } else {
        this.navItems[0]._children.forEach((element) => {
          element.show = element.id?.toUpperCase() === this.$route.meta.menuType.toUpperCase()
          if (element.dataOrg == 'need') {
            element._class = 'd-none'
          }
        })
      }

      this.hideMenuSubOrganization()
    },

    hideMenuSubOrganization() {
      if (!this.canCreateSubOrganization) {
        this.navItems[0]._children.forEach((element) => {
          if (element.id == 'Organization & Users') {
            element.items.forEach((el) => {
              if (el.item == 'subOrganization') {
                el.class = 'd-none'
              }
            })
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.asideBar {
  left: 0 !important;
  margin-left: 0px !important;
  &--fixed {
    margin-left: 0;
    position: absolute;
    left: 0;
    z-index: 2 !important;
    bottom: initial;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
